<span class="char-counter">{{ chars }}/{{ maxChars }} used</span>
